export default __webpack_public_path__ + "static/guide-37383de3860aa0289444e72746b4257a.png";